export const routesWithoutSidenav: RegExp[] = [
	/^\/quickPayment\/[^?&]+/,
	/^\/Login/,
	/^\/ResetPassword/,
	/^\/SignUp/,
];

export const hideSideNav = ( path: string ) =>
	routesWithoutSidenav.some( ( regex ) => regex.test( path ) );

export const routesWithoutStickyHeader: RegExp[] = [
	/^\/Login/,
	/^\/ResetPassword/,
	/^\/SignUp/,
];

export const hideStickyHeader = ( path: string ) =>
	routesWithoutStickyHeader.some( ( regex ) => regex.test( path ) );
